import React from 'react';
import Firebase from 'firebase';
import AdminsItem from './adminsItem'
import { Tooltip, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Select from 'react-select';
import AddAdmin from './addAdmin';


var ReactToastr = require("react-toastr");
var { ToastContainer } = ReactToastr;
var ToastMessageFactory = React.createFactory(ReactToastr.ToastMessage.animation);

export default class adminConfig extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
        this.editAdmin = this.editAdmin.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
    }

    componentWillMount() {
        var adminRef = Firebase.database().ref("admin_users");
        adminRef.on("value", snap => {
            this.setState({ admins: snap.val() })
        })
    }

    componentDidMount() {
        this.setState({ token: JSON.parse(localStorage["firebase:authUser:AIzaSyBUBm9Ccl_mancuvJ34gKRjCJT9hdtg384:[DEFAULT]"]).stsTokenManager.accessToken });
    }

    setUser(id) {
        var adminRef = Firebase.database().ref("admin_users").child(id);
        adminRef.once("value").then(snap => {
            this.setState({
                name: snap.val().name,
                rut: snap.val().rut,
                email: snap.val().email,
                client: snap.val().client_id,
                created_at: snap.val().created_at,
                photo: snap.val().photo
            })
        });
        var options = []
        var clientRef = Firebase.database().ref('clients')
            .once('value')
            .then(resp => {
                Object.keys(resp.val()).map(client => {
                    options.push({ value: client, label: client })
                })
            });
        this.setState({ clients: options });
    }

    deleteUser(id, client) {
        console.log("eliminando", id, client)
        const url = 'https://us-central1-operatio-a399c.cloudfunctions.net/api/admin/deleteUser';
        const data = {
            isAdmin: true,
            uid: id,
            client_id: client
        };

        fetch(url, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.state.token
            }
        })
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                } if (response.status === 403) {
                    this.refs.container.warning(
                        "USUARIO NO FUE Eliminado",
                        "", {
                            timeOut: 3000,
                            extendedTimeOut: 10000
                        });
                }

            })
            .then(jsonResponse => {
                this.refs.container.success(
                    "USUARIO ELIMINADO",
                    "usuario eliminado correctamente", {
                        timeOut: 3000,
                        extendedTimeOut: 10000
                    });
            })
            .catch(error => {
            });

    }


    editAdmin() {
        return (
            <div className="card">
                <div className="card-block">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Nombre:</label>
                                <input type="text" className="form-control" id="name" value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Email:</label>
                                <input type="text" className="form-control" id="name" value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Rut:</label>
                                <input type="text" className="form-control" id="name" value={this.state.rut} onChange={(e) => this.setState({ rut: e.target.value })} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="name" style={{ color: "#20a8d8" }}>Client:</label>
                                <Select
                                    name="form-field-name"
                                    value={this.state.client}
                                    options={this.state.clients}
                                    onChange={(e) => this.setState({ client: e.value })}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    sendUser() {
        var adminRef = Firebase.database().ref("admin_users").child(this.state.userId);
        adminRef.set({
            client_id: this.state.client,
            name: this.state.name,
            rut: this.state.rut,
            email: this.state.rut,
            created_at: this.state.created_at,
            modified_at: Firebase.database.ServerValue.TIMESTAMP,
            photo: this.state.photo ? this.state.photo : null,
            su: true

        }).then(resp => {
            this.setState({ showModal: false })
            this.refs.container.success(
                "Datos actualizados correctamente",
                "Usuario cctualizado", {
                    timeOut: 3000,
                    extendedTimeOut: 10000
                }
            )
        })
    }

    render() {
        return (
            <div className="card">
                <ToastContainer ref="container"
                    style={{ top: "60px" }}
                    toastMessageFactory={ToastMessageFactory}
                    className="toast-top-right"
                />
                <div className="card-header">
                    <span><i className="fa fa-align-left"></i> Listado de administradores</span>
                    <span style={{ right: "15px", position: "absolute", cursor: "pointer" }} onClick={() => this.setState({ showModalAdd: true })} >Nuevo Administrador <i className="fa fa-plus"></i></span>
                </div>
                <div className="card-block">
                    <table className="table table-hover table-outline mb-0 hidden-sm-down">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Cliente</th>
                                <th>Email</th>
                                <th>Rut</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.admins ?
                                Object.values(this.state.admins).map((c, index) => (
                                    <AdminsItem
                                        key={index}
                                        admin={c}
                                        adminId={Object.keys(this.state.admins)[index]}
                                        callBack={(id) => { this.setUser(id); this.setState({ userId: id, showModal: true }) }}
                                        deleteUser={this.deleteUser}
                                    />
                                ))
                                :
                                ""
                            }

                        </tbody>
                        <Modal isOpen={this.state.showModal} toggle={() => { this.setState({ showModal: false }) }} className="showModal-dialog showModal-lg">
                            <ModalHeader toggle={() => { this.setState({ showModal: false }) }}>
                            </ModalHeader>
                            <ModalBody>
                                {this.editAdmin()}
                            </ModalBody>
                            <ModalFooter>
                                <button onClick={() => this.sendUser()} type="button" className="btn btn-outline-success">Guardar</button>{' '}
                                <button onClick={() => { this.setState({ showModal: false }) }} type="button" className="btn btn-outline-warning">Cancelar</button>
                            </ModalFooter>
                        </Modal>
                        <Modal isOpen={this.state.showModalAdd} toggle={() => { this.setState({ showModalAdd: false }) }} className="showModal-dialog showModal-lg">
                            <ModalHeader toggle={() => { this.setState({ showModalAdd: false }) }}>
                            </ModalHeader>
                            <ModalBody>
                                <AddAdmin callBack={(name) => {
                                    this.setState({ showModalAdd: false }); this.refs.container.success(
                                        "Administrador creado correctamente",
                                        name, {
                                            timeOut: 3000,
                                            extendedTimeOut: 10000
                                        }
                                    )
                                }}
                                    options={this.state.clients} />
                            </ModalBody>
                        </Modal>
                    </table>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/administracion/admins/adminConfig.js